import React from 'react';
import StudentLaunch from '../domains/parent/components/StudentLaunch';

const StudentLaunchPage: React.FC = () => {
  return <StudentLaunch />;
};

export default StudentLaunchPage;

